import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Button } from 'src/app/components/Button/Button';
import { FormattedCustomMessage } from 'src/app/components/Formatted/FormattedCustomMessage';
import { EventTrack } from 'src/app/helpers/analytics';
import { withStyles } from 'src/app/helpers/styles';
import { LoginFunction } from 'src/app/models/login';

interface MyProps {
  login: LoginFunction;
  cancel: VoidFunction;
  loginFrom: string;
  eventTrack?: EventTrack;
}

@withStyles(require('./PopupLogin.scss'))
export class PopupLogin extends React.Component<MyProps> {
  render(): JSX.Element {
    return (
      <div onClick={this.handlePopupClick} className="p-20 bg-white position-absolute popup-login__container">
        <div className="mt-4 fs-12 fg-black ta-center">
          <FormattedCustomMessage id="popup.need.login" />
        </div>
        <div className="mt-24 d-flex jc-center">
          {this.renderCancelButton()}
          {this.renderLoginButton()}
        </div>
      </div>
    );
  }

  private handlePopupClick(e: React.MouseEvent<HTMLDivElement>): void {
    e.stopPropagation();
  }

  private renderCancelButton(): JSX.Element {
    return (
      <Button
        className="button--format-32 flex-1 mr-4 fs-12 tt-uppercase b-1 sg-gray ls-2 fg-gray"
        modifier="white"
        type="button"
        onClick={this.props.cancel}
      >
        <FormattedMessage id="label.button.cancel" />
      </Button>
    );
  }

  private renderLoginButton(): JSX.Element {
    const loginAction = (): void => {
      this.props.login(this.props.loginFrom, undefined, this.props.eventTrack);
    };
    return (
      <Button
        className="button--format-32 flex-1 ml-4 fs-12 tt-uppercase ls-2 fg-white"
        modifier="secondary"
        type="button"
        onClick={loginAction}
      >
        <FormattedMessage id="label.login" />
      </Button>
    );
  }
}
